import {modalCommentLink} from "./hoc/modalCommentLink";

const WaybillV2BulkResponsiblePersonReject = modalCommentLink('WaybillV2ResponsiblePersonReject')
export default WaybillV2BulkResponsiblePersonReject